import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import FolderSharedIcon from '@mui/icons-material/FolderShared'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone'
import MarkunreadMailboxIcon from '@mui/icons-material/MarkunreadMailbox'
import RoomServiceIcon from '@mui/icons-material/RoomService'
import SearchIcon from '@mui/icons-material/Search'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import { IconButton, InputAdornment, OutlinedInput } from '@mui/material'
import { styled } from '@mui/material/styles'
import { FC } from 'react'
import {
  AppBarProps,
  AppBar as RaAppBar,
  useDataProvider,
  useRedirect,
} from 'react-admin'
import { Link } from 'react-router-dom'
import { color, xxllncColor } from './themes'
import { UserMenu } from './UserMenu'

interface Conversation {
  id: string | number;
  channel: string;
}

const channelButtons = [
  {
    channel: 'phone',
    label: 'Telefoon',
    icon: <LocalPhoneIcon fontSize="small" />,
  },
  {
    channel: 'counter',
    label: 'Balie',
    icon: <RoomServiceIcon fontSize="small" />,
  },
  {
    channel: 'mail',
    label: 'Post',
    icon: <MarkunreadMailboxIcon fontSize="small" />,
  },
  {
    channel: 'person',
    label: 'Persoon',
    icon: <FolderSharedIcon fontSize="small" />,
  },
  {
    channel: 'email',
    label: 'E-mail',
    icon: <AlternateEmailIcon fontSize="small" />,
  },
  {
    channel: 'social',
    label: 'Sociaal',
    icon: <ThumbUpIcon fontSize="small" />,
  },
]

const AppBar: FC<AppBarProps> = (props) => {
  const dataProvider = useDataProvider()
  const redirect = useRedirect()

  const handleCreateConversation = async (channel: string) => {
    try {
      const { data } = await dataProvider.create<Conversation>('conversation', {
        data: { channel },
      })
      redirect('edit', 'conversation', data.id)
    } catch (error) {
      console.error('Creatie mislukt', error)
    }
  }

  return (
    <StyledAppBar
      className={classes.root}
      alwaysOn
      container="div"
      elevation={1}
      userMenu={<UserMenu />}
      {...props}
    >
      <Link
        to="/"
        className={classes.headerContainer}
        style={{ textDecoration: 'none' }}
      >
        <h1 className={classes.appLogo}>
          <span className={classes.vignet} aria-hidden="true">
            Kc
          </span>
          <span className={classes.appName}>Klantcontact</span>
        </h1>
      </Link>
      {channelButtons.map(({ channel, label, icon }) => (
        <IconButton
          key={channel}
          aria-label={label}
          sx={{ color: '#fff' }}
          onClick={() => {
            void handleCreateConversation(channel)
          }}
        >
          {icon}
        </IconButton>
      ))}

      <span className={classes.spacer} />

      <OutlinedInput
        type="search"
        size="small"
        sx={{ backgroundColor: '#fff' }}
        placeholder="Zoeken in klantcontact"
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        }
      />
    </StyledAppBar>
  )
}

const PREFIX = 'xxllncAppBar'

const classes = {
  root: `${PREFIX}-root`,
  spacer: `${PREFIX}-spacer`,
  headerContainer: `${PREFIX}-headerContainer`,
  appLogo: `${PREFIX}-appLogo`,
  appName: `${PREFIX}-appName`,
  vignet: `${PREFIX}-vignet`,
}

const StyledAppBar = styled(RaAppBar)(({ theme }) => ({
  [`&.${classes.root}`]: {
    color: color.white,
  },
  ['& .RaAppBar-toolbar']: {
    height: theme.spacing(4),
  },
  [`& .${classes.spacer}`]: {
    flex: 1,
  },
  [`& .${classes.headerContainer}`]: {
    maxWidth: '10rem',
    flex: 1,
  },
  [`& .${classes.appLogo}`]: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    fontSize: '0.8rem',
    fontWeight: 500,
  },
  [`& .${classes.vignet}`]: {
    backgroundColor: color.white,
    color: xxllncColor.blue100,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '2rem',
    width: '2rem',
    borderRadius: '0.5rem',
  },
  [`& .${classes.appName}`]: {
    color: color.white,
    fontSize: '0.8rem',
  },
}))

export default AppBar
